import {
  Dialog,
  DialogContent,
  Grid,
  withStyles,
  Theme,
} from "@material-ui/core";
import ContractsContext from "../../../context/ContractsContext/ContractsContext";
import { useContext, useEffect, useState } from "react";
import { colseExpiredContracts } from "../../../context/ContractsContext/Actions";
import styles from "../Contracts.module.css";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { useHistory } from "react-router-dom";
import {
  GET_CONTRACT_STATUS,
  GET_CONTRACT_STATUS_PAGINATION,
} from "../../../Querys/querys";
import { useLazyQuery } from "@apollo/client";
import moment from "moment";
import TableBits from "../../TableBits/TableBits";
import columns from "./ContractsColumn";
import MenuList from "./MenuList";
import FormatDateIngreso from "./FormatDateIngreso";
import FormatDateFinal from "./FormatDateFinal";
const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export const ExpiredContracts = () => {
  const history = useHistory();

  const { state, dispatch } = useContext(ContractsContext);
  const returnRenew = (idCollaborator: any) => {
    localStorage.currentPill = 1;
    localStorage.nextStep = 2;
    localStorage.lastSection = "contracts";
    history.push(`/collaborators/${idCollaborator}/1`, { from: "/contracts" });
  };

  const [
    getContracts,
    { data: resultContractStatus, startPolling, stopPolling },
  ] = useLazyQuery(GET_CONTRACT_STATUS_PAGINATION, {
    fetchPolicy: "no-cache",
  });

  const [contractsList, setContractsList] = useState<any>([]);
  const [contractsListFilter, setContractsListFilter] = useState<any[]>([]);

  const [pagination, setPagination] = useState({
    pageNumber: 0,
    rowsOfPage: 10,
    order: "asc",
    orderBy: "bussinesName",
    searchTerm: "",
  });

  const [paginationObj, setPaginationObj] = useState({
    rowsOfPage: 10,
    pageNumber: 0,
    searchTerm: "",
    order: "desc",
    orderBy: "FechaIngreso",
  });
  useEffect(() => {
    if (state.openExpiredContracts) {
      getContracts();
    } else {
      stopPolling();
    }
  }, [state.openExpiredContracts]);

  useEffect(() => {
    if (
      resultContractStatus &&
      resultContractStatus.GET_CONTRACT_STATUS_PAGINATION
    ) {
      setContractsList(resultContractStatus.GET_CONTRACT_STATUS_PAGINATION);
      setContractsListFilter(
        resultContractStatus.GET_CONTRACT_STATUS_PAGINATION
      );
      startPolling(10000);
      return () => {
        stopPolling();
      };
    }
  }, [resultContractStatus, startPolling, stopPolling]);

  return (
    <Dialog
      open={state.openExpiredContracts}
      aria-labelledby="form-dialog-title"
      maxWidth="lg"
      fullWidth={true}
    >
      <div className={styles.dialogContainer}>
        <div className={styles.containerTitle}>
          <div
            className={styles.centerContainer}           
          >
            <h2 id="form-dialog-title" data-testid="TitleModal">
              Contratos vencidos/por vencer
            </h2>
          </div>
          <div
            className={styles.contenedorCerrarModal}
            style={{
              width: "20px",
            }}
          >
            <div
              className={styles.iconoCerrarModal}
              onClick={() => colseExpiredContracts({}, dispatch)}
            ></div>
          </div>
        </div>

        <DialogContent className={styles.dialogoContento}>
           <>
            <TableBits
              columns={columns}
              rows={contractsListFilter}
              components={[
                null,
                FormatDateIngreso,
                FormatDateFinal,
                null,
                null,
              ]}
              componentOptions={MenuList}
              totalRecords={
                contractsListFilter?.length > 0
                  ? contractsListFilter[0]?.totalRows
                  : 0
              }
              getData={async (paginationObj_) => {
                setPaginationObj((val) => ({
                  ...val,
                  rowsPerPage: paginationObj_.rowsOfPage,
                  pageNumber: paginationObj_.pageNumber,
                }));
                getContracts({
                  variables: {
                    rowsPerPage: paginationObj_.rowsOfPage,
                    pageNumber: paginationObj_.pageNumber,
                    searchTerm: paginationObj.searchTerm,
                    order: paginationObj.order,
                    orderBy: paginationObj.orderBy,
                  },
                });
              }}
              updatePaginationObj={(paginationObj_) => {
                setPaginationObj((val) => ({
                  ...val,
                  order: paginationObj_.order,
                  orderBy: paginationObj_.orderBy,
                }));
                getContracts({
                  variables: {
                    rowsPerPage: paginationObj.rowsOfPage,
                    pageNumber: paginationObj.pageNumber,
                    searchTerm: paginationObj.searchTerm,
                    order: paginationObj_.order,
                    orderBy: paginationObj_.orderBy,
                  },
                });
              }}
              customInitialOrderBy="FechaIngreso"
              customInitialOrder="desc"
              customRowsPerPage={10}
              updatePageNumber={paginationObj.pageNumber}
            />
          </>
        </DialogContent>

        <DialogActions>
          <button
            className={styles.botonCancelar}
            onClick={() => colseExpiredContracts({}, dispatch)}
          >
            Cerrar
          </button>
        </DialogActions>
      </div>
    </Dialog>
  );
};
